import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {gameUiTexts} from 'data/ui-texts';
import videoGame1 from 'assets/videos/game1.mp4';
import videoGame2 from 'assets/videos/game2.mp4';

import Logos from 'components/ui/logos/logos';
import Logo from 'components/ui/logo/logo';
import Button from 'components/ui/button/button';
import './landing-page.scss';

const LandingPage = (props) => {	
	const {
		shuffleTasks, 
		ignoreTimer,
		scenarioId, 
		updateBackground, 
		handleStartGame, 
		resetGameProgress, 
		toggleShuffleTasks,
		toggleIgnoreTimer
	} = props;

	let videoSource = null;
	if (scenarioId === 'game1') {
		videoSource = videoGame1;
	} else if (scenarioId === 'game2') {
		videoSource = videoGame2;
	}
	
	useEffect(() => {
		// Set background image id
		updateBackground('landing', scenarioId);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="LandingPage">
			{videoSource && <video autoPlay loop={true} muted id={'backgroundVideo'}>
				<source src={videoSource} type={'video/mp4'}/>
			</video>}
			<div className="LandingPage-overlay" />
			<Logos />

			<div className="LandingPage-content">
				{/* Welcome */}
				<div className="LandingPage-welcome"><span>{gameUiTexts.welcomeTo}</span></div>

				{/* Logo */}
				<div className='LandingPage-logoWrapper'>
					<Logo scenarioId={scenarioId} page="landing"/>
				</div>

				{/* Start game btn */}
				<div className='LandingPage-startBtn'>
					<Button 
						classes={['blueLight', scenarioId, 'responsive']}
						text={gameUiTexts.start}
						onClick={() => {handleStartGame();}}
					/>
				</div>
			</div>

			{/* Reset game btn */}
			{(appConfig.env === 'development' || appConfig.env === 'test') && 
				<div className="LandingPage-resetBtn">
					<Button 
						classes={['login', scenarioId]} 
						text={gameUiTexts.resetBtn}
						onClick={() => {resetGameProgress();}}
					/>
				</div>
			}

			{(appConfig.env === 'development' || appConfig.env === 'test') && 
				<div 
					className={'LandingPage-toggleShuffleTasks' + (shuffleTasks ? ' checked' : '')}
					onClick={() => {toggleShuffleTasks();}}
				>
					<span>Shuffle tasks</span>
				</div>
			}
			{(appConfig.env === 'development' || appConfig.env === 'test') && 
				<div 
					className={'LandingPage-toggleIgnoreTimer' + (ignoreTimer ? ' checked' : '')}
					onClick={() => {toggleIgnoreTimer();}}
				>
					<span>Ignore timer</span>
				</div>
			}
		</div>
	);
};

LandingPage.propTypes = {
	shuffleTasks: PropTypes.bool.isRequired,
	ignoreTimer: PropTypes.bool.isRequired,
	scenarioId: PropTypes.string.isRequired,
	updateBackground: PropTypes.func.isRequired,
	handleStartGame: PropTypes.func.isRequired,
	resetGameProgress: PropTypes.func.isRequired,
	toggleShuffleTasks: PropTypes.func.isRequired,
	toggleIgnoreTimer: PropTypes.func.isRequired
};

export default LandingPage;
